<template>
  <div ref="lightbox" class="glightbox"></div>
</template>

<script>
import GLightbox from 'glightbox'

export default {
  props: {
    images: Array
  },
  data () {
    return {
      lightbox: null
    }
  },
  methods: {
    open () {
      this.lightbox.open()
    },
    close () {
      this.lightbox.close()
    },
    loadImages () {
      const images = (this.images || [])
        .filter(image => !!image)
        .map(image => {
          return {
            href: image,
            type: 'image'
          }
        })
      this.lightbox.setElements(images)
      this.lightbox.reload()
    }
  },
  watch: {
    images (newValue) {
      // reload the images when they change
      this.loadImages()
    }
  },
  mounted () {
    // create the lightbox
    this.lightbox = GLightbox({
      'selector': 'glightbox'
    })
    // load the images
    this.loadImages()
  },
  beforeDestroy () {
    try {
      this.lightbox.destroy()
    } catch (e) {
      console.debug(e)
      // lightbox throws an error when it's being destroyed without any images.
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../node_modules/glightbox/dist/css/glightbox.css";
</style>
